// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClockCounterIcon } from '@moia-dev/pace-icons'
import { TracingAreaRoutes } from './TracingAreaRoutes'

export const TracingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={TracingAreaRoutes.route}
      Icon={ClockCounterIcon}
    />
  )
}
